export default function Story() {
  return "";
}
